import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=0f2b7ccc&scoped=true&"
import script from "./TenantDetail.vue?vue&type=script&lang=ts&"
export * from "./TenantDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TenantDetail.vue?vue&type=style&index=0&id=0f2b7ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b7ccc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
